import { Button } from '@/components/atoms/Button';
import Image from 'next/image';

interface SelectedFilterOptionTagProps {
  option: {
    filterId: string;
    filterName: string;
    optionName: string;
    selectedAt: number;
  };
  onChangeCheckedFilter: (filterId: string, optionName: string) => void;
  compact?: boolean;
}

export function SelectedFilterOptionTag({
  option,
  onChangeCheckedFilter: onChangeCheckedFilter,
  compact = false,
}: SelectedFilterOptionTagProps) {
  return (
    <Button
      onClick={() => onChangeCheckedFilter(option.filterId, option.optionName)}
      variant="outline"
      className={`w-fit
        ${compact ? 'h-6 border-(--secondary-400) rounded-[37.5px] px-3 py-1.5 caption-11r text-(--secondary-700) gap-0.75' : 'h-8 border-(--secondary-400) rounded-[50px] px-4 py-2 body-14m text-(--secondary-700) gap-1'}`}
    >
      {option.optionName}
      {compact ? (
        <Image src="/images/x.svg" alt="cancel" width={12} height={12} />
      ) : (
        <Image src="/images/x.svg" alt="cancel" width={16} height={16} />
      )}
    </Button>
  );
}
